module.exports = "<ntc-header></ntc-header>\r\n\r\n<div class=\"container-fluid\">\r\n    <div class=\"row\">\r\n        <ntc-sidebar></ntc-sidebar>\r\n\r\n        <main role=\"main\" class=\"col-sm-9 ml-sm-auto col-md-10 pt-3\" [ngClass]=\"{'sidebar-hide': !sideBar.sideBarVisible}\">\r\n            <router-outlet></router-outlet>\r\n        </main>\r\n    </div>\r\n      \r\n</div>\r\n\r\n<ntc-footer></ntc-footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main